// Testi/CTA di conversione centralizzati (pronti per futuri A/B test) + checkout helper.
import api from "./api";
import { trackEvent } from "./analytics";

export const UPSELL_COPY = {
    analysis_result: {
        eyebrow: "HAI ANALIZZATO LA TUA PRIMA ASTA",
        body: "Ora non fermarti a una sola opportunità. Con Standard puoi analizzare fino a {limit} aste al mese e valutare più opportunità prima di decidere dove investire.",
        cta: "Continua con Standard — {price}",
        features: null,
    },
    second_analysis_paywall: {
        eyebrow: "VUOI ANALIZZARE ANCHE QUESTA OPPORTUNITÀ?",
        body: "Conosci rischi, costi, valore, ROI e offerta massima prima di decidere quanto offrire.",
        cta: "Sblocca {limit} analisi — {price}",
        features: [
            "{limit} analisi al mese",
            "Import documenti e OCR",
            "Analisi completa dell'operazione",
            "Calcolo dell'offerta massima",
            "Report professionale",
        ],
    },
    dashboard: {
        eyebrow: "LA TUA PRIMA ANALISI È COMPLETATA",
        body: "Pronto ad analizzare la prossima opportunità?",
        cta: "Passa a Standard",
        features: null,
    },
    plan_required: {
        eyebrow: "È NECESSARIO UN PIANO",
        body: "Attiva Standard per analizzare le opportunità con il motore a 8 agenti.",
        cta: "Attiva Standard — {price}",
        features: null,
    },
};
export const UPSELL_MICROCOPY = "Disdici quando vuoi.";
export const UPSELL_SECONDARY = "Confronta tutti i piani";

let _plans = null;
export async function getPlans() {
    if (_plans) return _plans;
    const { data } = await api.get("/payments/plans");
    _plans = data;
    return _plans;
}

export const fmtEur = (v) => `€${Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2 })}`;

export const fillCopy = (text, std) =>
    text.replace("{limit}", std?.monthly_limit ?? 5).replace("{price}", fmtEur(std?.price_eur ?? 19.9));

export const isFreeQuotaExceeded = (err) =>
    err?.response?.status === 402 &&
    err?.response?.data?.detail?.reason === "quota_exceeded" &&
    err?.response?.data?.detail?.plan === "free";

export async function startStandardCheckout(source, returnTo) {
    trackEvent("upgrade_clicked", source);
    const { data } = await api.post("/payments/checkout", {
        plan: "standard",
        origin_url: window.location.origin,
        source,
        return_to: returnTo || null,
    });
    window.location.href = data.checkout_url;
}
